import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import Store from 'store/store';

import { joinClasses } from 'utils/utils';
import { navigateInternally } from 'utils/bolt/index';
import { getDynamicData, transformPageData } from 'utils/bolt/dynamicData';
import parseQueryString from 'utils/parseQueryString';
import hooks from 'utils/hooks';

import s from 'base/bolt/boltApp.sss';

const queryTitleRedirections = {
	// 'fantastic-four': 'fantastic-four',
	'the-bad-guys-2': 'bad-guys-2',
	// 'weapons': 'weapons',
	'shin-godzilla-4k': 'shin-godzilla',
	// 'nobody-2': 'nobody-2',
	jaws: 'jaws50',
	dogma: 'dogma25',
};
const getRedirectionTarget = (title) => Store.get().appData?.pages?.[queryTitleRedirections[title] || title]?.id;

// Do not allow ?title=thing if it matches the movie slug: the title query string is used for redirections below (see maybeRedirectToFilmPage)
hooks.register('querystring.filters.movie', async ids => ids.filter(id => !queryTitleRedirections[id] && !getRedirectionTarget(id)));

export default class BoltApp extends BaseComp.default {
	maybeRedirectToFilmPage() {
		const query = parseQueryString();
		if (!query.title) {
			return;
		}
		const desiredPage = getRedirectionTarget(query.title);

		if (!desiredPage) return;
		navigateInternally(desiredPage);
		// remove the query string
		window.history.replaceState(null, null, window.location.pathname);

	}

	async componentDidMount() {
		super.componentDidMount?.();
		const { previewDataPath } = parseQueryString();
		await this.loadFilmPages(previewDataPath);
		Store.get().set({ dynamicDataLoaded: true });
		this.maybeRedirectToFilmPage();
	}

	async loadFilmPages(previewDataPath) {
		const data = await getDynamicData('film-pages');
		const pages = Object.values(data || {}).flatMap(transformPageData);
		Store.get().appData.pages.set(Object.fromEntries(pages.map(p => [p.id, p]))).now();
		const desiredPage = data[previewDataPath]?.url;
		if (desiredPage) {
			navigateInternally(desiredPage);
		}
	}

	renderMain(props, state) {
		const base = super.renderMain(props, state);
		const showtimesOpen = Store.get().showtimes?.showtimesOpen;
		if (showtimesOpen) {
			base.attributes.class = joinClasses(base.attributes.class, s.showtimesOpen);
		}
		return base;
	}

}